import {
  BaseRecord,
  CustomResponse,
  useCustomMutation,
  useTranslate,
} from "@refinedev/core";
import { useAnalytics } from "hooks/useAnalytics/";
import { AnalyticsEvents } from "types/analytics/";

export const useRegenerateMedia = (
  refetchProjectDetail: () => void,
  mediaId: string | undefined,
  projectId: string | undefined,
  mediaStatus: string | undefined
) => {
  const t = useTranslate();
  const { mutateAsync: regenerateMedia, isPending: isRegenerating } =
    useCustomMutation<CustomResponse<BaseRecord>>();

  const { trackEvent } = useAnalytics();

  // Returns whether the regenerate call actually succeeded — callers (e.g.
  // the out-of-date widget's dismissal bookkeeping) rely on this to tell a
  // real success from a swallowed failure.
  const handleRegenerateMedia = async (): Promise<boolean> => {
    try {
      if (!projectId || !mediaId) return false;
      await regenerateMedia({
        url: `media/media/${mediaId}/regenerate`,
        method: "post",
        values: {},
        successNotification: {
          type: "success",
          message: t("projects.components.ProjectMedias.regenerateSuccess"),
        },
      });

      trackEvent(AnalyticsEvents.ProjectMediaRegenerate, {
        project_id: projectId,
        media_status: mediaStatus ?? "unknown",
        media_id: mediaId,
      });

      refetchProjectDetail();
      return true;
    } catch (e) {
      console.debug(e);
      return false;
    }
  };

  return { handleRegenerateMedia, isRegenerating };
};
